const iniatialState = {
    category: "ALL",
    author: "ALL"
}
export default iniatialState;